











































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs,
  useStore,
  watch
} from '@nuxtjs/composition-api'

import DButton from '~/components/atoms/DS2/DButton'
import DSelectButton from '~/components/atoms/DS2/DSelectButton'
import SearchConditionSelectContentWrapper from '~/components/organisms/DS2/SearchConditionSelect/components/SearchConditionSelectContentWrapper'
import SearchConditionSelectCassette from '~/components/organisms/DS2/SearchConditionSelect/components/SearchConditionSelectCassette'
import { ConditionOptionGroup, DisplayPosition } from '~/types/services/search'

const searchConditionSelect = defineComponent({
  name: 'SearchConditionSelect',
  components: {
    DButton,
    DSelectButton,
    SearchConditionSelectContentWrapper,
    SearchConditionSelectCassette,
    SearchConditionSelectModal: () =>
      import('~/components/organisms/DS2/SearchConditionSelectModal' /* webpackChunkName: "SearchConditionSelectModal" */),
    SearchConditionSelectContent: () =>
      import('~/components/organisms/DS2/SearchConditionSelectContent' /* webpackChunkName: "SearchConditionSelectContent" */)
  },
  props: {
    conditionOptionGroup: {
      type: Object as PropType<ConditionOptionGroup>,
      default: () => ({})
    },
    displayPosition: {
      type: String as PropType<DisplayPosition>,
      default: 'left'
    },
    isSelected: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isConditionChanged: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  setup(props, context) {
    const store = useStore()
    const { conditionOptionGroup } = toRefs(props)
    const isShowContent = ref<boolean>(false)
    const elRoot = ref<HTMLElement>()

    const isPC = computed<boolean>(() => {
      return store.getters['ui/isPC']
    })

    const onBlurHandler = (event: Event): void => {
      // TODO: category_v2 引数を渡すところでTypeScriptの型警告が出てしまったが、解決方法がすぐに分からなかったので後ほど対応する
      // targetがコンポーネントの中に含まれているものなら何もしない
      // @ts-ignore
      if (elRoot.value.contains(event.target)) {
        return
      }
      onCloseSearchContent()
    }

    const toggleSearchContent = (): void => {
      if (isShowContent.value) {
        // 閉じる時
        onCloseSearchContent()
      } else {
        // 開く時
        isShowContent.value = true
      }
    }

    const onClear = (facetGroupKey: string): void => {
      context.emit('clear', facetGroupKey)
    }

    const onSearch = (): void => {
      context.emit('search')
      onCloseSearchContent()
    }

    const onCloseSearchContent = (): void => {
      context.emit('close', conditionOptionGroup.value.key)
      isShowContent.value = false
    }

    watch(isShowContent, newVal => {
      if (isPC.value) {
        if (newVal) {
          window.addEventListener('click', onBlurHandler)
        } else {
          window.removeEventListener('click', onBlurHandler)
        }
      }
    })

    return {
      elRoot,
      isPC,
      isShowContent,
      toggleSearchContent,
      onClear,
      onSearch,
      onCloseSearchContent
    }
  }
})

export default searchConditionSelect
